export const DOCUMENT_TYPES_MDMS_SUCCESS = "DOCUMENT_TYPES_MDMS_SUCCESS"



// WEBPACK FOOTER //
// ./src/redux/store/actionTypes.js